(function () {
  var pad = function (n) { return (n < 10 ? "0" : "") + n; };
  var box = document.querySelector("[data-countdown]");
  if (box) {
    var end = new Date(box.getAttribute("data-end")).getTime();
    var note = document.querySelector("[data-countdown-note]");
    var q = function (k) { return box.querySelector('[data-cd="' + k + '"]'); };
    var tick = function () {
      var left = end - Date.now();
      if (isNaN(end) || left <= 0) { box.hidden = true; if (note) note.hidden = true; return false; }
      q("d").textContent = pad(Math.floor(left / 864e5));
      q("h").textContent = pad(Math.floor(left % 864e5 / 36e5));
      q("m").textContent = pad(Math.floor(left % 36e5 / 6e4));
      q("s").textContent = pad(Math.floor(left % 6e4 / 1e3));
      return true;
    };
    if (tick()) {
      box.hidden = false; if (note) note.hidden = false;
      var iv = setInterval(function () { if (!tick()) clearInterval(iv); }, 1000);
    }
  }
  var sticky = document.getElementById("stickyBuy"), card = document.getElementById("comprar");
  if (sticky && card && "IntersectionObserver" in window) {
    new IntersectionObserver(function (en) { sticky.style.visibility = en[0].isIntersecting ? "hidden" : "visible"; }, { threshold: 0.2 }).observe(card);
  }
})();

/* Compra única: el ebook es digital, así que siempre se compra 1 unidad */
(function () {
  var busy = false;
  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (!f || !f.action || f.action.indexOf("/cart/add") === -1) return;
    var idEl = f.querySelector('[name="id"]');
    if (!idEl) return;
    e.preventDefault();
    if (busy) return;
    busy = true;
    var json = { "Content-Type": "application/json", "Accept": "application/json" };
    fetch("/cart/clear.js", { method: "POST", headers: json })
      .catch(function () {})
      .then(function () {
        return fetch("/cart/add.js", { method: "POST", headers: json, body: JSON.stringify({ items: [{ id: Number(idEl.value), quantity: 1 }] }) });
      })
      .then(function (r) {
        if (!r.ok) throw new Error("add");
        window.location.href = "/checkout";
      })
      .catch(function () { busy = false; f.submit(); });
  }, true);
})();
